export { DealsBanner } from './DealsBanner';
export { default } from './DealsBanner';

const DEAL_UNIT_KEYS = [
	'smallUnit',
	'mediumUnit',
	'largeUnit',
	'enclosed',
	'outdoorCovered',
	'outdoorUncovered',
	'indoor',
	'recommendedUnit',
];

export function getDealText(units, isDealsPage) {
	if (!isDealsPage || !units) return null;
	return (
		DEAL_UNIT_KEYS.map((key) => units[key]).find((u) => u?.special)
			?.special ?? null
	);
}
